import { render, staticRenderFns } from "./Vuelidate.vue?vue&type=template&id=89ed1f52&"
import script from "./Vuelidate.vue?vue&type=script&lang=js&"
export * from "./Vuelidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports